var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('index-view'),_c('LoginDialog',{attrs:{"initial-mode":_vm.loginDialogMode},on:{"send-code":_vm.handleSendCode,"submit":_vm.handleSubmit},model:{value:(_vm.loginDialogVisible),callback:function ($$v) {_vm.loginDialogVisible=$$v},expression:"loginDialogVisible"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }